import { ComponentType } from 'react';

export type SectionLink = {
  backlink?: string | null;
  badge?: number | string;
  filePath: string;
  headerComponent?: ComponentType;
  icon: string;
  key: string;
  label: string;
  headerLabel?: string;
  routePath: string;
  subHeaders?: SubHeader[];
  to: string;
  visible: boolean;
  status?: string;
};

export type SubHeader = {
  exact?: boolean;
  label: string;
  onClick?: () => unknown;
  pageTitle?: string;
  superAdminOnly?: boolean;
  to: string;
  visible: boolean;
  status?: string;
};

export type SectionLinksObject = {
  links: SectionLink[];
  redirectPath: string;
};

// Exact match or a path segment below `to` -- plain substring matching (e.g. `pathname.includes(to)`)
// wrongly treats "/menu-boards" as active for a link whose `to` is "/menu", since "/menu-boards"
// contains "/menu" as a substring without being a sub-path of it.
export function isLinkActive(pathname: string, to: string): boolean {
  return pathname === to || pathname.startsWith(`${to}/`);
}
